import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ServiceAccessStore } from '../store/service-access.store';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Guard que protege la ruta /payments
 * Bloquea el acceso si la cuenta no tiene permisos de wallet_extraction ni bank_extraction
 */
export const serviceAccessGuard: CanActivateFn = (route, state) => {
  const serviceAccessStore = inject(ServiceAccessStore);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const hasWallet = serviceAccessStore.hasAccessToService('wallet_extraction');
  const hasBank = serviceAccessStore.hasAccessToService('bank_extraction');

  if (!hasWallet && !hasBank) {
    snackBar.open('Esta cuenta no tiene acceso a solicitudes de pago', 'Entendido', {
      duration: 5000,
      panelClass: ['mat-snack-error'],
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });

    router.navigate(['/']);
    return false;
  }

  return true;
};
